import { Injectable } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';
@Injectable({
    providedIn: 'root',
})
export class UrlTrackerService {
    private previousUrl: string = undefined;
    private currentUrl: string = undefined;
    public menuItemClicked = false;
    public urlHistory: string[] = [];

    constructor(public router: Router) {
        this.currentUrl = router.url;
        this.previousUrl = router.url;
        router.events
            .pipe(
                filter((evt: any) => evt instanceof RoutesRecognized),
                pairwise(),
            )
            .subscribe((events: RoutesRecognized[]) => {
                // console.log(events);
                this.previousUrl = events[0].urlAfterRedirects;
                this.currentUrl = events[1].urlAfterRedirects;
            });
    }

    public getPreviousUrl(): string {
        return this.previousUrl;
    }

    public getCurrentUrl(): string {
        return this.currentUrl;
    }
}
